/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Bank_NumberInputs */

const vi_grower_bank_number = /** @type {(inputs: Grower_Bank_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tài khoản`)
};

/**

* @param {Grower_Bank_NumberInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_bank_number = /** @type {((inputs?: Grower_Bank_NumberInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Bank_NumberInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_bank_number(inputs)
});